import React from 'react';
import { LegalTabNavigation } from '../../../../components/LegalTabNavigation';

import styles from '../../styles.sass';

export function TermsOfService({ pathname }) {
  return (
    <div className={styles.wrapper}>
      <div className={styles.container}>
        <h1 className={styles.h1}>Anchor Terms of Service</h1>
        <LegalTabNavigation pathname={pathname} />
        <p>Date of Last Revision: October 23, 2019</p>
        <section>
          <p>
            These Terms of Service, our <a href="/dmca">Copyright Policy</a>,
            and all other operating rules, policies and guidelines, each of
            which is incorporated by reference (collectively the “
            <strong>Terms</strong>”), govern your access to and use of the
            Anchor websites, Monetization Services, APIs, email notifications,
            applications, buttons, widgets, ads and other services
            (collectively, the “Services”) provided by Spotify (“
            <strong>Spotify</strong>”, “<strong>we</strong>”, “
            <strong>us</strong>”, or “<strong>our</strong>” means: (a) if you
            are an entity organized under or otherwise subject to the laws of
            the United States of America: Spotify USA Inc., a Delaware
            Corporation with offices at 4 World Trade Center, 150 Greenwich
            Street, 62nd Floor, New York, New York 10007; or (b) if you are an
            entity organized under or otherwise subject to the laws of any
            country outside of the United States of America: Spotify AB, of
            Regeringsgatan 19, 111 53 Stockholm, Sweden, with registered number
            556703-7495).{' '}
            <strong>
              By clicking “Sign up” or by using our Services, you agree to these
              Terms. If you do not agree to these Terms, do not access or use
              our Services
            </strong>
            .
          </p>
          <p className={styles.explainer}>
            <em>
              Explainer: Your agreement is with Spotify. The service is still
              called Anchor and we’re still the easiest way to make a podcast.
            </em>
          </p>
          <p>
            <strong>
              THESE TERMS CONTAIN A MANDATORY ARBITRATION PROVISION THAT, AS
              FURTHER SET FORTH IN SECTION 14 BELOW, REQUIRES THE USE OF
              ARBITRATION ON AN INDIVIDUAL BASIS TO RESOLVE DISPUTES, RATHER
              THAN JURY TRIALS OR ANY OTHER COURT PROCEEDINGS, OR CLASS ACTIONS
              OF ANY KIND.
            </strong>
          </p>
          <p>
            <strong>
              To assist you with your review of the agreement, we provide at the
              end of most sections of these Terms a short, very high-level
              “Explainer” of some of the key concepts from that section. These
              Explainers are included for reference purposes only, do not
              necessarily explain all key points in the Terms, do not constitute
              contractual terms and are not a substitute for reading the actual
              contractual terms; the Explainers will not affect the meaning or
              interpretation of these Terms, and, in all cases, the substantive
              language of these Terms (and not any Explainer) will govern and
              take priority over any summary.
            </strong>
          </p>
          <p>
            We reserve the right to modify or otherwise change these Terms at
            any time by posting the updated Terms to our website(s) or through a
            notice provided through the Services, via e-mail or by another
            appropriate means of electronic communication. Any such changes will
            not apply to any dispute between you and us arising prior to the
            date on which we posted the revised Agreement incorporating such
            changes, or otherwise notified you of such changes. Unless we say
            otherwise in our notice, the updated Terms will be effective
            immediately, and your continued access to or use of our Services
            after we post the updated Terms or provide other notice of such
            updated Terms will confirm your acceptance of the changes. If you do
            not agree to the updated Terms, you must stop accessing and using
            our Services.
          </p>
          <p>
            We also reserve the right to modify or discontinue, temporarily or
            permanently, or suspend the Services (or any part thereof) with or
            without notice. We may also impose limits on certain features and
            services or restrict your access to parts or all of the Services
            without notice or liability. You agree that we will not be liable to
            you or to any third party for any modification, suspension or
            discontinuance of Services.
          </p>
        </section>
        <section>
          <h2>1. Eligibility</h2>
          <p>
            In order to access or use the Services, you need to (a) be at or
            above the age of majority in your province, state, territory or
            country (often, but not always, 18 years old), or be 13 years or
            older and have your parent or legal guardian consent to these Terms
            on your and their behalf; and (b) have the power to enter a binding
            contract with us and not be barred from doing so under any
            applicable laws. You also promise that any registration information
            that you submit to Spotify is true, accurate, and complete, and you
            agree to keep it that way at all times. You must notify us
            immediately of any change in your eligibility to use the Services.
            We may, in our sole discretion, refuse to offer the Services to any
            person or entity and change these eligibility criteria at any time.
          </p>
          <p className={styles.explainer}>
            <em>
              Explainer: You cannot use Anchor if you are under 13 years old. If
              you are 13 years or older but under the age of majority (e.g.
              often 18 years of age), you need parental/guardian consent to use
              Anchor.
            </em>
          </p>
        </section>
        <section>
          <h2>2. Registration</h2>
          <p>
            To use some aspects of the Services, you must register for an
            account (an "<strong>Account</strong>"). Registration data and
            certain other information about you and your Account are governed by
            our Privacy Policy. You will not: (a) select or use as a username a
            name of another person with the intent to impersonate that person;
            (b) use as a username a name subject to any rights of a person
            (including, without limitation, copyrights or trademarks) other than
            you without appropriate authorization; or (c) use, as a username, a
            name that we reasonably consider is otherwise offensive, vulgar or
            obscene. You are solely responsible for the activity that occurs on
            your Account and for keeping your Account password secure. You may
            never use another person’s user account or registration information
            for the Services without permission. You must notify us immediately
            of any breach of security or unauthorized use of your Account. You
            should never publish, distribute or post login information for your
            Account. We will not be liable for any loss or damage arising from
            your failure to comply with this Section. You will have the ability
            to delete your Account, either by following the instructions on the
            Services or by contacting us via our help page.
          </p>
          <p className={styles.explainer}>
            <em>
              Explainer: You are responsible for keeping your Account details
              secure, and you need to notify us of any unauthorized use of your
              Account. When choosing a username, please be respectful and only
              choose one you are authorized to use.
            </em>
          </p>
        </section>
        <section>
          <h2>3. Ownership; Limited License</h2>
          <p>
            The Services, including the text, graphics, images, photographs,
            videos, illustrations and other content contained therein, are owned
            by Spotify or our licensors and are protected under both United
            States and foreign laws. Except as explicitly stated in these Terms,
            all rights in and to the Services are reserved by us or our
            licensors. Subject to your compliance with these Terms, you are
            hereby granted a limited, nonexclusive, nontransferable,
            non-sublicensable, revocable license to access and use our Services.
            Any use of the Services other than as specifically authorized
            herein, without our prior written permission, is strictly
            prohibited, will terminate the license granted herein and violate
            our intellectual property rights.
          </p>
        </section>
        <section>
          <h2>4. User Content</h2>
          <ol className={styles.lowerLatinList}>
            <li>
              <h3>User Content</h3>
              <p>
                All information, materials and other content added, created,
                uploaded, submitted, distributed, or posted to the Services by
                users (collectively “User Content”), whether publicly posted or
                privately transmitted, is the sole responsibility of the person
                or entity who so added, created, uploaded, submitted,
                distributed, or posted such User Content on the Services. You
                represent that all User Content provided by you is in compliance
                with all applicable laws, rules and regulations, including, but
                not limited to, copyright laws. You acknowledge that your access
                to all User Content through the Services is at your own risk and
                you will be solely responsible for any damage or loss to you or
                any other party resulting therefrom. We do not pre-screen User
                Content and do not guarantee that any User Content you access on
                or through the Services is or will continue to be accurate.
              </p>
              <p>
                We do not guarantee that any User Content will be made available
                through the Services. You acknowledge that we may establish
                general practices and limits concerning use of the Services,
                including without limitation the maximum period of time that
                User Content will be retained by the Services and the maximum
                storage space that will be allotted on our servers on your
                behalf. You agree that we have no responsibility or liability
                for the deletion or failure to store any User Content maintained
                or uploaded by the Services. We reserve the right to, but do not
                have any obligation to, (a) remove any User Content in our sole
                discretion, at any time, without notice to you and for any
                reason (including, but not limited to, upon receipt of claims or
                allegations from third parties or authorities relating to such
                User Content or if we are concerned that you may have violated
                these Terms), or for no reason at all and (b) to remove or block
                any User Content from the Services.
              </p>
              <p className={styles.explainer}>
                <em>
                  Explainer: You’re responsible for making sure the content you
                  create or post on Anchor does not breach any laws or
                  regulations, and does not infringe on anyone else’s rights.
                </em>
              </p>
            </li>
          </ol>
        </section>
        <section>
          <h2>5. Rights you grant to us</h2>
          <ol className={styles.lowerLatinList}>
            <li>
              <h3>User Content</h3>
              <p>
                <strong>
                  You retain ownership of your User Content. Using Anchor does
                  not cause you to lose ownership of your content.
                </strong>
              </p>
              <p className={styles.explainer}>
                <em>
                  Explainer: <strong>You own your content</strong>. Anchor
                  prides itself on empowering creators, and we have no intention
                  to take ownership of your content in any way.
                </em>
              </p>
              <p>
                In order to host and assist you in monetizing your User Content,
                we do need to obtain certain non-exclusive rights from you. By
                submitting User Content, including any Provided Content (defined
                below), through the Services, you hereby grant to us a
                non-exclusive license to use, edit, modify, create derivative
                works from (such as transcriptions of User Content), aggregate,
                reproduce, distribute, make available, transmit, display, and
                perform, the User Content in connection with the operation of
                the Services, the promotion, advertising or marketing of the
                Services, and the operation of Spotify’s (and its successors’
                and affiliates’) business. This license is worldwide,
                royalty-free, sublicensable (through multiple tiers) and
                transferable.
              </p>
              <p className={styles.explainer}>
                <em>
                  Explainer: In order to use Anchor, you are giving us
                  permission to use, host, and distribute the content you
                  create. For example, this license allows us to syndicate your
                  content to other platforms, so that your audience can hear
                  your podcast anywhere they choose. We believe strongly in
                  creators’ rights, and in no way does this license take away
                  the ownership rights you have in your content.
                </em>
              </p>
              <p>
                You agree that this license includes, without limitation, the
                right for Spotify to provide, promote, and improve the Services.
                We may also use this license to make User Content available to
                other companies, organizations or individuals who partner with
                Spotify for the syndication, broadcast, distribution,
                transmission or publication of such User Content on other media
                and services.
              </p>
              <p className={styles.explainer}>
                <em>
                  Explainer: One of the best parts of Anchor is the ability to
                  create in one place and optionally let us handle the hassle of
                  distributing your podcast everywhere. This language allows us
                  to distribute your content on your behalf, so that you can
                  focus on creating and leave the technical headache of podcast
                  distribution to us. You are also welcome to distribute your
                  podcast to other platforms manually if you prefer.
                </em>
              </p>
              <p>
                For the avoidance of doubt, such license includes any and all
                rights in or to the User Content, including, without limitation,
                copyright, rights of privacy or rights of publicity. Where
                applicable and permitted under applicable law, you also agree to
                waive and not enforce any “moral rights” or rights, such as your
                right to be identified as the author of your User Content,
                including Feedback, and your right to object to derogatory
                treatment of such User Content. If such moral rights are not
                waivable, then you at least agree not to sue us for failure to
                identify you as the author of any User Content or for any use of
                your User Content on or in connection with the Service.
              </p>
              <p>
                You represent and warrant that you have all rights to grant such
                licenses to us without infringement or violation of any third
                party rights, including without limitation, any privacy rights,
                publicity rights, copyrights, trademarks, contract rights, or
                any other intellectual property or proprietary rights. You also
                agree that, if you create your User Content with one or more
                collaborators, you will ensure that each such collaborator
                either (a) has an Account and has agreed to these Terms or (b)
                has granted to you all of the rights that you need in order for
                you to grant the licenses that you grant to us herein in such
                User Content.
              </p>
              <p className={styles.explainer}>
                <em>
                  Explainer: By using Anchor, you are representing that your
                  User Content does not infringe anyone else’s rights, and you
                  are granting us the rights we need to provide the Services,
                  including to share your User Content on Anchor and other
                  distribution platforms.
                </em>
              </p>
            </li>
            <li>
              <h3>Provided Content</h3>
              <p>
                The Services may include features that allow other users and/or
                listeners to create User Content that is provided to you for use
                in connection with your User Content, such as through the “Voice
                Messages” and “Record with Friends” features (“
                <strong>
                  <em>Provided Content</em>
                </strong>
                ”). If your User Content makes use of or includes any Provided
                Content, or any other content created by any third party, you
                represent and warrant that you have all rights and permissions
                necessary to grant the licenses granted in Section 5(a) above.
              </p>
              <p>
                If you create, contribute content for, produce, record,
                participate in, contribute to, share or otherwise assist in
                creating any Provided Content for use by another user’s Account,
                you grant to such user a non-exclusive license to use, edit,
                modify, create derivative works from (including transcriptions
                of Provided Content), aggregate, reproduce, distribute, make
                available, transmit, display, and perform the Provided Content
                in connection with the operation of the Services, promotion,
                advertising or marketing of the Services, and the operation of
                Spotify’s (and its successors’ and affiliates’) business. This
                license is worldwide, royalty-free, sublicensable (through
                multiple tiers) and transferable. You acknowledge and understand
                that any sharing of Provided Content with one or more other
                users is voluntary, and the recipient of any Provided Content
                has no obligation to incorporate or otherwise use such Provided
                Content in their User Content. You also agree that, if another
                user decides to use your Provided Content in connection with
                such user’s User Content, this does not result in you acquiring
                an ownership interest in such User Content.
              </p>
              <p className={styles.explainer}>
                <em>
                  Explainer: If you provide any content for use in connection
                  with another person’s User Content, you give them the right to
                  use that content. If you receive any content from another
                  person and incorporate that into your User Content, you must
                  ensure you have all necessary permissions to use it.
                </em>
              </p>
            </li>
            <li>
              <h3>Feedback</h3>
              <p>
                If you provide feedback, ideas or suggestions to Spotify in
                connection with the Service or (
                <strong>
                  <em>Feedback</em>
                </strong>
                ), you acknowledge that the Feedback is not confidential and you
                authorize Spotify to use that Feedback without restriction and
                without payment to you. Feedback is considered a type of User
                Content.
              </p>
              <p className={styles.explainer}>
                <em>
                  Explainer: We love when our users give feedback or propose
                  ideas. We encourage you to do so! We just ask that you be
                  aware that while we may follow through on your proposals, they
                  are not confidential, and we unfortunately can't pay you for
                  them.
                </em>
              </p>
            </li>
          </ol>
        </section>
        <section>
          <h2>6. User Guidelines</h2>
          <p>
            Objectionable Content. Spotify respects intellectual property rights
            and expects you to do the same. We’ve established a few ground rules
            for you to follow when using the Services or submitting User Content
            to the Service, to make sure the Service stays enjoyable for
            everyone. The current rules are listed below, but these may be
            updated, or we may provide you with additional rules, from time to
            time. You agree to follow these rules.
          </p>
          <p>The following is not permitted for any reason whatsoever:</p>
          <ol className={styles.lowerLatinList}>
            <li>
              copying, redistributing, reproducing, “ripping”, recording,
              transferring, performing or displaying to the public,
              broadcasting, or making available to the public any part of the
              Services or User Content, or otherwise making any use of the
              Services or User Content which is not expressly permitted under
              the Terms or applicable law or which otherwise infringes the
              intellectual property rights (such as copyright) in the Services
              or User Content or any part of it;
            </li>
            <li>
              using the Services to distribute, reproduce, record, perform or
              display any music content for which you do not have all necessary
              rights;
            </li>
            <li>
              using the Services to import or copy any local files you do not
              have the legal right to import or copy in this way;
            </li>
            <li>
              transferring copies of cached User Content from an authorized
              terminal device to any other device via any means;
            </li>
            <li>
              reverse-engineering, decompiling, disassembling, modifying, or
              creating derivative works based on the Services or User Content or
              any part thereof unless permitted by applicable law;
            </li>
            <li>
              circumventing any technology used by Spotify, its licensors, or
              any third party to protect Spotify, the Services or User Content;
            </li>
            <li>
              selling, renting, sub-licensing or leasing of any part of the
              Services or User Content;
            </li>
            <li>
              circumventing any territorial restrictions applied by Spotify or
              its licensors;
            </li>
            <li>
              manipulating the Services by using a script or other automated
              process;
            </li>
            <li>
              taking any action that imposes an unreasonable load on the
              Services;
            </li>
            <li>
              removing or altering any copyright, trademark, or other
              intellectual property notices contained on or provided through the
              Services (including for the purpose of disguising or changing any
              indications of the ownership or source of any User Content);
            </li>
            <li>
              “crawling” the Services or otherwise using any automated means
              (including bots, scrapers, and spiders) to collect information
              from Spotify or the Services, provided that, and subject to
              compliance with any instructions posted in the robots.txt file
              located in the root directory associated with the Services,
              Spotify (i) grants to the operators of public search engines
              permission to use spiders to copy materials from the Services for
              the sole purpose of (and solely to the extent necessary for)
              creating publicly available, searchable indices of such materials
              (excluding the audio content included within an audio file), but
              not caches or archives of such materials, and (ii) reserves the
              right to revoke such permission at any time and without notice;
            </li>
            <li>
              framing or linking to any of the materials or information
              available on Spotify’s website or the Services; or
            </li>
            <li>
              deleting or altering any material Spotify or any other user makes
              available on the Services;
            </li>
            <p>
              Please respect Spotify, the owners of the User Content, yourself,
              and other users of the Services. Don’t engage in any activity,
              submit any User Content, or register and/or use a username, which
              is or includes material that:
            </p>
            <li>
              would violate any agreement to which you are a party, such as, by
              way of example and not limitation, an exclusive recording
              agreement or publishing agreement;
            </li>
            <li>
              is offensive, abusive, defamatory, pornographic, threatening,
              obscene, or advocates or incites violence;
            </li>
            <li>
              is illegal, or intended to promote or commit an illegal act of any
              kind, including but not limited to violations of intellectual
              property rights, privacy rights, or proprietary rights of Spotify
              or a third party;
            </li>
            <li>
              includes your password or purposely includes any other user’s
              password or purposely includes personal data of third parties or
              is intended to solicit such personal data;
            </li>
            <li>
              includes malicious content such as malware, Trojan horses, or
              viruses, or otherwise interferes with any user’s access to the
              Services;
            </li>
            <li>is intended to or does harass or bully other users;</li>
            <li>
              impersonates or misrepresents your affiliation with another user,
              person, or entity, or is otherwise fraudulent, false, deceptive,
              or misleading;
            </li>
            <li>artificially promotes content;</li>
            <li>
              involves the transmission of unsolicited mass or commercial
              electronic mail or text messages or other forms of spam;
            </li>
            <li>
              involves commercial or sales activities or pyramid schemes, that
              are not expressly authorized by Spotify;
            </li>
            <li>
              exposes confidential or proprietary information of a third party
              or personal information about yourself that you do not wish to
              make available to people around the world;
            </li>
            <li>
              interferes with or in any way disrupts the Services, tampers with,
              breaches, or attempts to probe, scan, or test for vulnerabilities
              in the Services or Spotify’s computer systems, network, usage
              rules, or any of Spotify’s security components, authentication
              measures or any other protection measures applicable to the
              Services, the User Content or any part thereof; or
            </li>
            <li>
              conflicts with the Terms, as determined by Spotify, collectively
              (“Objectionable Content”).
            </li>
          </ol>
          <p>
            You agree that you will not assist any person in engaging, or permit
            or encourage any person to engage, in any Objectionable Content.
          </p>
          <p>
            You acknowledge and agree that posting any Objectionable Content may
            result in immediate termination or suspension of your Anchor
            account. Spotify may also reclaim your username for any reason,
            including, but not limited to, for the purpose of giving your
            username to another user of the Services, and Spotify will have no
            liability to you if it does so. Spotify has a set of Anchor
            Community Guidelines that further govern the conduct of all users of
            the Service. You will also comply with other such guidelines
            incorporated herein by reference.
          </p>
          <p>
            Please be thoughtful about how you use the Services and what you
            submit. The Services include the ability to post User Content and
            make certain information about you public. Remember that shared or
            publicly available information may be used and re-shared by other
            users on the Services or across the web, and may live on in
            perpetuity once posted, so please submit User Content on the
            Services carefully. Spotify has no responsibility for your choices
            to post User Content on the Services.
          </p>
          <p>
            We also reserve the right to access, read, preserve, and disclose
            any information as we reasonably believe is necessary to (i) satisfy
            any applicable law, regulation, legal process or governmental
            request, (ii) enforce these Terms, including investigation of
            potential violations hereof, (iii) detect, prevent, or otherwise
            address fraud, security or technical issues, (iv) respond to user
            support requests, or (v) protect the rights, property or safety of
            us, our users and the public.
          </p>
          <p className={styles.explainer}>
            <em>
              Explainer: There are various types of content that are strictly
              forbidden on Anchor, like content that is stolen, dangerous,
              abusive, harmful, or illegal. Use common sense and you'll be fine!
            </em>
          </p>
        </section>
        <section>
          <h2>7. Trademarks</h2>
          <p>
            The “Anchor” and “Spotify” name and logos are trademarks and service
            or brand identifier’s marks of Spotify (collectively the “
            <strong>
              <em>Spotify Trademarks</em>
            </strong>
            ”). Other company, product, and service names and logos used and
            displayed via the Services may be trademarks or service marks of
            their respective owners who may or may not endorse or be affiliated
            with or connected to us.
          </p>
          <p>
            Nothing in these Terms or the Services should be construed as
            granting, by implication, estoppel, or otherwise, any license or
            right to use any of Spotify Trademarks displayed on the Services,
            without our prior written permission in each instance. All goodwill
            generated from the use of Spotify Trademarks will inure to our
            exclusive benefit.
          </p>
          <p className={styles.explainer}>
            <em>
              Explainer: You must not use any Spotify Trademarks (including the
              “Anchor” name and logo) without written permission from Spotify.
            </em>
          </p>
        </section>
        <section>
          <h2>8. Third Party Services</h2>
          <p>
            The Services may permit you to link to other websites, online
            services or resources, and other websites, online services or
            resources may contain links to the Services. When you access third
            party resources, you do so at your own risk. These other resources
            are not under our control, and you acknowledge that we are not
            responsible or liable for the content, functions, accuracy,
            legality, appropriateness or any other aspect of such websites or
            resources. The inclusion of any such link does not imply our
            endorsement or any association between us and their operators.
          </p>
          <p>
            You further acknowledge and agree that we will not be responsible or
            liable, directly or indirectly, for any damage or loss caused or
            alleged to be caused by or in connection with the use of or reliance
            on any such third party content, goods or services available on or
            through any such third party website, online service or resource.
          </p>
          <p className={styles.explainer}>
            <em>
              Explainer: We do not review or monitor external links put in
              Anchor content. Please be careful when clicking any link to the
              outside world, and please be mindful of which links you add to
              your own content.
            </em>
          </p>
        </section>
        <section>
          <h2>9. Monetization Services</h2>
          <ol className={styles.lowerLatinList}>
            <li>
              <h3>Monetization Services</h3>
              <p>
                The Services may include certain tools to help you develop,
                launch, operate and market your User Content for the purpose of
                monetizing and enabling you to collect money through your usage
                of the Services, such as the “Listener Support” and
                “Sponsorships” features, (collectively, the “
                <strong>
                  <em>Monetization Services</em>
                </strong>
                ”). We may implement additional operating rules, policies and
                procedures relating to the use of Monetization Services from
                time to time, by posting them to our website(s) or through a
                notice provided through the Services, via e-mail or by another
                appropriate means of electronic communication. Such rules,
                policies and procedures, in addition to these Terms, will govern
                your access to and use of the Monetization Services. To the
                extent you use Monetization Services in connection with your
                User Content, such User Content will become “
                <strong>
                  <em>Monetized Content</em>
                </strong>
                ”.
              </p>
              <p>
                You acknowledge that you may be required to have an account with
                our third party payment providers in order to use the
                Monetization Services. Your use of any such third party payment
                providers is subject to such provider’s terms of use and privacy
                policy. If you are located outside the United States of America,
                some or all of the Monetization Services may be unavailable.
              </p>
              <p className={styles.explainer}>
                <em>
                  Explainer: Anchor has tools that will help you make money off
                  your content, if you’re eligible.
                </em>
              </p>
            </li>
            <li>
              <h3>Sponsorships</h3>
              <p>
                The Monetization Services may enable you to opt in to the
                Sponsorships feature, by inserting one or more segments into
                your User Content to be sponsored by a third party that chooses
                to advertise with Anchor (such third party being a “
                <strong>
                  <em>Sponsor</em>
                </strong>
                ”). If you choose to use the Sponsorships feature, you
                acknowledge that there is no guarantee of being connected with
                any Sponsors or receiving any sponsorship for such segments.
              </p>
              <p>
                If you accept a Sponsor’s request to support a segment through
                the Services (such segment being a “
                <strong>
                  <em>Sponsored Segment</em>
                </strong>
                ”), you must record the Sponsored Segment in accordance with
                these Terms and any additional requirements or obligations a
                Sponsor may impose in connection with your Monetized Content,
                including but not limited to, attribution or promotional
                obligations (“
                <strong>
                  <em>Sponsored Requirements</em>
                </strong>
                ”). To the extent any Sponsor Requirements conflict with these
                Terms, you must comply with these Terms.
              </p>
              <p>
                You are in no way precluded from monetizing your User Content in
                ways other than the usage of the Monetization Services. If you
                do monetize your User Content outside of the Monetization
                Services, please note that you are still responsible for using
                the Services in a way that complies with these Terms.
              </p>
              <p>
                You will be entitled to receive revenue based on the number of
                impressions of a Sponsored Segment, as measured by Anchor based
                on data received from its own metrics and those of all
                applicable podcast distributors. Revenue collected from Sponsors
                of your Monetized Content will be distributed to your Account in
                accordance with the{' '}
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://help.anchor.fm/hc/en-us/articles/360012563112-Cashing-out-from-your-wallet-"
                >
                  Fee Schedule
                </a>{' '}
                as it relates to payments from Sponsors.
              </p>
              <p className={styles.explainer}>
                <em>
                  Explainer: Using our Sponsorships feature, you may be able to
                  add ad segments into your podcasts and earn revenue based on
                  the number of impressions. You are always free to monetize
                  your show in your own way, if you prefer not to use
                  Sponsorships.
                </em>
              </p>
            </li>
            <li>
              <h3>Embedded Advertising</h3>
              <p>
                You will ensure that all advertising or sponsorship messages
                contained in your User Content, including those provided through
                the Monetization Services, comply with Spotify’s Advertising
                Editorial Policies, which may be updated from time to time and
                which are currently located at{` `}
                <a
                  style={{ wordBreak: 'break-all' }}
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://www.spotify.com/brands/legal/advertiser-terms-and-conditions/#s4"
                >
                  https://www.spotify.com/brands/legal/advertiser-terms-and-conditions/#s4
                </a>
                , or a successor link. Notwithstanding the foregoing, you
                acknowledge that advertising and/or sponsorship messages
                containing pornographic content, or for firearms, ammunition,
                weapons, cigarettes, tobacco or e-cigarettes, or that relate to
                political or religious organizations or paid advertising for any
                competitive music or audio streaming services, is not permitted.
                No data provided by Spotify or acquired by you in relation to
                usage of the User Content on the Services may be used for the
                purposes of targeting for advertisers. You shall not use the
                “Spotify” name or brand marks, including the “Anchor” name or
                brand marks, in any advertising sales collateral without prior
                approval from Spotify. Spotify reserves the right to remove any
                User Content that contains any embedded advertising and/or
                sponsorship messages that do not comply with these Terms. You
                agree that cookies may only be used in and/or in relation to the
                User Content to improve the user experience.
              </p>
              <p className={styles.explainer}>
                <em>
                  Explainer: We have some restrictions on the types of
                  advertising you can embed into your podcasts.
                </em>
              </p>
            </li>
            <li>
              <h3>Listener Support</h3>
              <p>
                The Monetization Services may enable you to accept financial
                contributions from listeners who subscribe to your User Content
                through the Listener Support feature (“Subscribers”). You
                acknowledge that Subscriber support is voluntary and may be
                cancelled at any time, and that you have no right to any future
                amounts from Subscribers.
              </p>
              <p>
                If you are a Subscriber to any User Content, you acknowledge
                that we use a third party payment provider to process all
                payments, and that you are subject to such provider’s terms of
                use and privacy policy when you interact with that provider.
                Your support through the Listener Support feature is voluntary,
                and you may cancel your subscription for any User Content by
                following the instructions provided to you when you subscribed
                to that User Content, or otherwise as set out on our website(s).
                You further acknowledge that your support of User Content as a
                Subscriber does not grant you any rights in User Content.
              </p>
              <p className={styles.explainer}>
                <em>
                  Explainer: Listeners may be able to subscribe to content
                  through our ‘Listener Support’ feature. If you use this
                  feature to support content, you can cancel your subscription
                  at any time.
                </em>
              </p>
            </li>
            <li>
              <h3>Fees and Payment</h3>
              <p>
                The amount of revenue or financial support earned through your
                use of the Monetization Services may be subject to certain fees
                retained by Spotify in accordance with the applicable sections
                of the{' '}
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://help.anchor.fm/hc/en-us/articles/360012563112-Cashing-out-from-your-wallet-"
                >
                  Fee Schedule
                </a>
                . Variations or changes to the Fee Schedule as they pertain to
                your usage of the Monetization Services may be agreed upon from
                time to time with Spotify in writing. Spotify reserves the right
                to charge you a portion of any costs of any chargeback or credit
                card fees or mobile platform fees that Spotify incurs in
                connection with its management of your Monetized Content or your
                usage of the Monetization Services. Without limiting anything
                herein to the contrary, Spotify also reserves the right to
                change the Fee Schedule from time to time, with reasonable prior
                notice to you in writing. Fees may be withdrawn from revenue
                prior to it becoming available to you. The ability to withdraw
                revenue may be delayed before it becomes available to you, or
                may be subject to other restrictions such as minimum amount
                withdrawal thresholds.
              </p>
              <p>
                Unless stated otherwise, the amounts to be paid under this
                Agreement are exclusive of VAT, GST, HST, sales taxes or other
                similar taxes, duties, charges or assessments ("
                <strong>Indirect taxes</strong>"). Indirect taxes will be added
                on top of agreed amounts as per local legislation. Each party
                shall be solely responsible for payment of all Indirect taxes it
                is legally obliged to pay arising as a result of this Agreement
                or otherwise. Further each party shall be solely responsible for
                collection and remittance of all Indirect taxes it is legally
                obliged to collect and remit. Each party shall be solely
                responsible for payment of any tax assessed on its income. The
                Parties acknowledge that as of the Effective Date and to the
                best of their knowledge, there is no withholding tax applicable
                to payments due under this Agreement. In case the local law and
                /or changing in the law requires the application of withholding
                tax, both parties will work together to mitigate it..The parties
                further acknowledge that they will collect all relevant
                documentation needed in the event of a tax audit.
              </p>
              <p className={styles.explainer}>
                <em>
                  Explainer: If you monetize your content through Anchor, your
                  funds will be subject to certain fees and may be subject to
                  taxes.
                </em>
              </p>
            </li>
            <li>
              <h3>Suspension; Refunds</h3>
              <p>
                If Spotify believes you are abusing the Monetization Services in
                any way, or are being negligent in your communication
                Subscribers, or believes that you are being negligent with your
                upkeep of the Monetized Content, Spotify may, in its sole
                discretion and without limiting other remedies, limit, suspend,
                or terminate your Account(s) and access to the Monetization
                Services, delay or remove hosted content, remove any special
                status associated with your Account(s), remove, not display,
                and/or demote listings, reduce or eliminate any discounts, and
                take technical and/or legal steps to prevent you from using the
                Spotify Services. Spotify reserves the right to, in its sole
                discretion, refund subscription fees paid by Subscribers to your
                Monetized Content or to your Account, and/or payments paid by
                Sponsors for your Monetized Content, in which case you shall
                reimburse Spotify for such refund payments. To the extent that
                you fail to reimburse such payments to Spotify, you hereby agree
                that Spotify may offset such refund payments to Subscribers or
                Sponsors against subsequent payments required to be made to you
                by Subscribers through the Monetization Services.
              </p>
              <p className={styles.explainer}>
                <em>
                  Explainer: We have the right to suspend or terminate your
                  account if we think you are misusing the monetization
                  features.
                </em>
              </p>
            </li>
            <li>
              <h3>Responsibilities.</h3>
              <div>
                You are solely responsible for your Monetized Content and your
                usage of the Monetization Services and compliance with any laws
                or regulations related to them, including without limitation,
                the following:
                <ol className={styles.lowerRomanList}>
                  <li>
                    Any claims or warranties you make in connection with the
                    Monetization Services and any claims made by other users
                    against you as they relate to the Monetized Content or your
                    usage of the Monetization Services;
                  </li>
                  <li>
                    Handling any comments or complaints related to your usage of
                    the Monetization Services, including without limitation any
                    issues related to payments, promotions, refunds or
                    chargebacks. You agree to provide accurate and complete
                    contact information to Subscribers so that they can submit
                    comments or complaints;
                  </li>
                  <li>
                    Compliance with any consumer, securities and related laws
                    and regulations; and
                  </li>
                  <li>
                    Any claims arising out of your disparagement of Sponsors in
                    your User Content, including any Monetized Content.
                  </li>
                </ol>
              </div>
              <p className={styles.explainer}>
                <em>
                  Explainer: By monetizing your content, you are responsible for
                  complying with applicable laws and responding to complaints
                  related to that content.
                </em>
              </p>
            </li>
            <li>
              <h3>No Obligation to Examine Monetized Content.</h3>
              <p>
                You acknowledge and agree that Spotify is not responsible for
                examining or warranting the Monetized Content through the
                Monetization Services, and you will not attempt to hold Spotify
                or Spotify’s third party service providers liable for
                inaccuracies. You shall ensure that all Monetized Content and
                other content and information directly associated with your
                usage of the Monetization Services is accurate. You further
                acknowledge and agree that, while Spotify has no obligation to
                do so, Spotify may monitor, review, revise, modify, analyze,
                evaluate, obfuscate or delete the Monetized Content, including
                any data or content associated with the Monetized Content, to,
                among other things, supplement, remove or correct information,
                in its sole discretion, as well as to provide you with optional
                recommendations to consider when creating and operating the
                Monetized Content.
              </p>
            </li>
            <li>
              <h3>User Guidelines</h3>
              <p>
                The restrictions in Section 6 above (User Guidelines) apply to
                your use of the Monetization Services and all Monetized Content.
              </p>
            </li>
          </ol>
        </section>
        <section>
          <h2>10. Termination</h2>
          <p>
            We may terminate your access to all or any part of the Services at
            any time, for any reason, which may result in the forfeiture and
            destruction of all information, including User Content, associated
            with your Account. You agree that we will not be liable to you or
            any third party, including Sponsors associated with your use of the
            Monetization Services, for any termination of your access to or use
            of the Services.
          </p>
          <p>
            If you wish to terminate your Account, you may do so by contacting
            us via our help page.
          </p>
          <p>
            All provisions of these Terms of Service which by their nature
            should survive termination will survive termination, including,
            without limitation, licenses of User Content, ownership provisions,
            warranty disclaimers, indemnity and limitations of liability.
          </p>
          <p className={styles.explainer}>
            <em>
              Explainer: Common sense and generally being a nice person means
              you can use Anchor all you wish! But if we do terminate your
              account for any reason, we have the ability to do so without a
              guarantee that we will notify you.
            </em>
          </p>
        </section>
        <section>
          <h2>11. Warranty Disclaimer</h2>
          <p>
            <strong>
              To the fullest extent permitted under applicable law:
            </strong>
          </p>
          <p>
            <strong>
              We have no special relationship with you or fiduciary duty to you.
            </strong>
          </p>
          <p>
            <strong>
              You acknowledge that we have no duty to take any action regarding:
              which users gain access to the Services; what content you access
              via the Services; or how you may interpret or use the content.
            </strong>
          </p>
          <p>
            <strong>
              You release us from all liability for you having acquired or not
              acquired content through the Services. We make no representations
              concerning any content contained in or accessed through the
              Services, and we will not be responsible or liable for the
              accuracy, copyright compliance, or legality of material or content
              contained in or accessed through the Services.
            </strong>
          </p>
          <p>
            <strong>
              The Services are provided “AS IS”, “AS AVAILABLE” and without
              warranty of any kind, express, statutory or implied, including,
              but not limited to, the implied warranties of title,
              non-infringement, merchantability and fitness for a particular
              purpose, and any warranties implied by any course of performance
              or usage of trade, all of which are expressly disclaimed. We and
              our affiliates, and our and their officers, directors,
              shareholders, employees, agents, suppliers, partners and
              third-party content providers, and any successors or assigns, do
              not warrant and expressly disclaim that: (i) the Services will be
              secure or available at any particular time or location; (ii) any
              defects or errors will be corrected; (iii) the Services are free
              of viruses or other harmful components; or (iv) the results of
              using the Services will meet your requirements. your use of the
              Services is solely at your own risk.
            </strong>
          </p>
          <p className={styles.explainer}>
            <em>
              Explainer: We do our best to build the best darn podcasting
              platform in the world. But we can't make any guarantees. You agree
              we won't be liable if it ever doesn't work as intended, or if you
              come across content or users that you're not happy with.
            </em>
          </p>
        </section>
        <section>
          <h2>12. INDEMNIFICATION.</h2>
          <p>
            To the fullest extent permitted under applicable law: You will
            defend, indemnify, and hold harmless us, our affiliates and each of
            our and their respective employees, directors, suppliers, partners,
            contractors, third-party licensors and representatives (the “
            <strong>Indemnified Parties</strong>”) from all liabilities, claims,
            and expenses, including reasonable attorneys’ fees, that arise from
            or relate to (1) your breach, or alleged breach, of the Terms; (2)
            any User Content that you post or otherwise contribute or make
            available; (3) any activity in which you engage on or through the
            Services; (4) your violation of any law or the rights of a third
            party; and (5) any dispute you may have with another User or
            collaborator in connection with any User Content or use of the
            Services.
          </p>
          <p>
            We reserve the right to assume the exclusive defense and control of
            any matter otherwise subject to indemnification by you, in which
            event you will assist and cooperate with us in asserting any
            available defenses. You agree not to involve Spotify in any dispute
            you may have with another User or collaborator.
          </p>
          <p className={styles.explainer}>
            <em>
              Explainer: If we ever get sued and it's because you violated these
              terms or any rules or laws, or because you created content that
              caused someone else to sue us, you agree to reimburse us for the
              consequences of your misdeeds or that content.
            </em>
          </p>
        </section>
        <section>
          <h2>13. Limitation of Liability</h2>
          <p>
            <strong>
              This Section 13 applies to the fullest extent permitted under
              applicable law:
            </strong>
          </p>
          <p>
            <strong>
              You agree that your sole and exclusive remedy for any problems or
              dissatisfaction with the Services is to stop using the Service.
              you agree that Spotify has no obligation or liability arising from
              or related to third party services made available through or in
              connection with the Services.
            </strong>
          </p>
          <p>
            <strong>
              In no event will Spotify and its affiliates, and its and their
              officers, directors, shareholders, employees, agents, suppliers,
              partners or third-party licensors, and any successors or assigns,
              be liable for (1) any indirect, special, incidental, punitive,
              exemplary, or consequential damages; (2) any loss of use, data,
              business, or profits (whether direct or indirect), in all cases
              arising out of the use of or inability to use the Services, or
              third party services, regardless of legal theory, without regard
              to whether Spotify has been warned of the possibility of those
              damages, and even if a remedy fails of its essential purpose; or
              (3) aggregate liability for all claims relating to the Services
              more than the amounts paid by you to Spotify during the prior
              twelve months in question.
            </strong>
          </p>
          <p>
            <strong>
              Nothing in the Terms removes or limits Spotify’s liability for
              fraud, fraudulent misrepresentation, death or personal injury
              caused by its negligence, and, if required by applicable law,
              gross negligence.
            </strong>
          </p>
          <p>
            <strong>
              You agree that any claim against Spotify must be commenced (by
              filing a demand for arbitration under Section 14 or filing an
              individual action under Section 15(a) within one (1) year after
              the date the party asserting the claim first knows or reasonably
              should know of the act, omission, or default giving rise to the
              claim; and there shall be no right to any remedy for any claim not
              asserted within that time period. If applicable law prohibits a
              one-year limitation period for asserting claims, any claim must be
              asserted within the shortest time period permitted by applicable
              law.
            </strong>
          </p>
          <p className={styles.explainer}>
            <em>
              Explainer: We have no intention of this ever happening, but if we
              do something that somehow causes you to suffer a financial loss,
              you agree to a limit on how much we are required to reimburse you.
            </em>
          </p>
        </section>
        <section>
          <h2>14. Arbitration</h2>
          <ol className={styles.lowerLatinList}>
            <li>
              <h3>Dispute resolution and arbitration</h3>
              <p>
                You and Spotify agree that any dispute, claim, or controversy
                between you and Spotify arising in connection with or relating
                in any way to these Terms or to your relationship with Spotify
                as a user of the Service (whether based in contract, tort,
                statute, fraud, misrepresentation, or any other legal theory,
                and whether the claims arise during or after the termination of
                these Terms) will be determined by mandatory binding individual
                (not class) arbitration. You and Spotify further agree that the
                arbitrator shall have the exclusive power to rule on his or her
                own jurisdiction, including any objections with respect to the
                existence, scope or validity of the Arbitration Agreement or to
                the arbitrability of any claim or counterclaim. Arbitration is
                more informal than a lawsuit in court. THERE IS NO JUDGE OR JURY
                IN ARBITRATION, AND COURT REVIEW OF AN ARBITRATION AWARD IS
                LIMITED. There may be more limited discovery than in court. The
                arbitrator must follow this agreement and can award the same
                damages and relief as a court (including attorney fees), except
                that the arbitrator may not award any relief, including
                declaratory or injunctive relief, benefiting anyone but the
                parties to the arbitration. This arbitration provision will
                survive termination of these Terms.
              </p>
            </li>
            <li>
              <h3>Exceptions</h3>
              <p>
                Notwithstanding the clause above Section 14(a), you and Spotify
                both agree that nothing in this Arbitration Agreement will be
                deemed to waive, preclude, or otherwise limit either of our
                rights, at any time, to (1) bring an individual action in a U.S.
                small claims court or (2) bring an individual action seeking
                only temporary or preliminary individualized injunctive relief
                in a court of law, pending a final ruling from the arbitrator.
                In addition, this Arbitration Agreement doesn’t stop you or us
                from bringing issues to the attention of federal, state, or
                local agencies. Such agencies can, if the law allows, seek
                relief against us on your behalf (or vice versa).
              </p>
            </li>
            <li>
              <h3>
                No Class or Representative Proceedings: Class Action Waiver
              </h3>
              <p>
                YOU AND SPOTIFY AGREE THAT EACH MAY BRING CLAIMS AGAINST THE
                OTHER ONLY IN YOUR OR ITS INDIVIDUAL CAPACITY AND NOT AS A
                PLAINTIFF OR CLASS MEMBER IN ANY PURPORTED CLASS OR
                REPRESENTATIVE ACTION. Unless both you and Spotify agree, no
                arbitrator or judge may consolidate more than one person’s
                claims or otherwise preside over any form of a representative or
                class proceeding. The arbitrator may award injunctive relief
                only in favor of the individual party seeking relief and only to
                the extent necessary to provide relief warranted by that party’s
                individual claim. If a court decides that applicable law
                precludes enforcement of any of this paragraph’s limitations as
                to a particular claim for relief, then that claim (and only that
                claim) must be severed from the arbitration and may be brought
                in court.
              </p>
            </li>
            <li>
              <h3>Arbitration rules</h3>
              <p>
                Either you or we may start arbitration proceedings. Any
                arbitration between you and Spotify will take place under the
                Consumer Arbitration Rules of the American Arbitration
                Association (“AAA”) then in force (the “AAA Rules”), as modified
                by this Arbitration Agreement. You and Spotify agree that the
                Federal Arbitration Act applies and governs the interpretation
                and enforcement of this provision (despite the choice of law
                provision above). The AAA Rules, as well as instructions on how
                to file an arbitration proceeding with the AAA, appear at
                adr.org, or you may call the AAA at 1-800-778-7879. Spotify can
                also help put you in touch with the AAA. Any arbitration
                hearings will take place in the county (or parish) of your
                billing address, provided that if the claim is for $25,000 or
                less, you may choose whether the arbitration will be conducted
                (1) solely on the basis of documents submitted to the
                arbitrator; (2) through a non-appearance based telephonic
                hearing; or (3) by an in-person hearing as established by the
                AAA Rules in the county (or parish) of your billing address. If
                you choose to file an arbitration proceeding and you are
                required to pay a filing fee, Spotify will reimburse you for
                that filing fee, unless your claim is for greater than US
                $10,000, in which case you will be responsible for the filing
                fee. Spotify will pay any other arbitration fees, including your
                share of arbitrator compensation, unless otherwise required by
                AAA rules or court order. Regardless of the manner in which the
                arbitration is conducted, the arbitrator shall issue a reasoned
                written decision sufficient to explain the essential findings
                and conclusions on which the decision and award, if any, are
                based. The arbitrator may make rulings and resolve disputes as
                to the payment and reimbursement of fees or expenses at any time
                during the proceeding and upon request from either party made
                within 14 days of the arbitrator’s ruling on the merits.
              </p>
            </li>
            <li>
              <h3>Notice; Process</h3>
              <p>
                A party who intends to seek arbitration must first send a
                written notice of the dispute to the other, by certified mail,
                Federal Express, UPS, or Express Mail (signature required), or
                in the event that we do not have a physical address on file for
                you, by electronic mail ("Notice"). Spotify's address for Notice
                is: Spotify USA Inc. Attn: General Counsel, 4 World Trade
                Center, 150 Greenwich Street, 62nd Floor, New York, New York
                10007, USA. The Notice must (1) describe the nature and basis of
                the claim or dispute; and (2) set forth the specific relief
                sought ("Demand"). We agree to use good faith efforts to resolve
                the claim directly, but if we do not reach an agreement to do so
                within 30 days after the Notice is received, you or Spotify may
                commence an arbitration proceeding. During the arbitration, the
                amount of any settlement offer made by you or Spotify shall not
                be disclosed to the arbitrator until after the arbitrator makes
                a final decision and award, if any. In the event our dispute is
                finally resolved through arbitration in your favor, and the
                arbitrator issues you an award that is greater than the value of
                Spotify’s last written settlement offer, then Spotify will
                instead pay you either the amount of the award or $1,000,
                whichever is greater. All documents and information disclosed in
                the course of the arbitration shall be kept strictly
                confidential by the recipient and shall not be used by the
                recipient for any purpose other than for purposes of the
                arbitration or the enforcement of the arbitrator’s decision and
                award and shall not be disclosed except in confidence to persons
                who have a need to know for such purposes or as required by
                applicable law.
              </p>
            </li>
            <li>
              <h3>Enforceability</h3>
              <p>
                If this Arbitration Agreement is invalidated in whole or in
                part, the parties agree that the exclusive jurisdiction and
                venue described in Section 15 shall govern any claim in court
                arising out of or related to these Terms.
              </p>
            </li>
          </ol>
          <p className={styles.explainer}>
            <em>
              Explainer: If you and Anchor ever have a disagreement (and we hope
              that never happens!), instead of facing the lengthy and expensive
              process of going to court, we agree to use the alternative dispute
              resolution process described here.
            </em>
          </p>
        </section>
        <section>
          <h2>15. Miscellaneous</h2>
          <ol className={styles.lowerLatinList}>
            <li>
              <h3>Governing Law and Jurisdiction.</h3>
              <p>
                These Terms will be governed by and construed in accordance with
                the laws of the United States (including federal arbitration
                law) and the State of New York, United States of America,
                without regard to choice or conflicts of law principles. You
                agree that any dispute arising from or relating to the subject
                matter of these Terms or otherwise not subject to arbitration
                will be subject to the exclusive jurisdiction and venue of the
                Southern District of New York.
              </p>
            </li>
            <li>
              <h3>New Jersey Consumers</h3>
              <p>
                If you are a consumer residing in New Jersey, the following
                provisions of these Terms do not apply to you (and do not limit
                any rights that you may have) to the extent that they are
                unenforceable under New Jersey law: (i) the disclaimer of
                liability for any indirect, incidental, consequential, special,
                exemplary or punitive damages of any kind (for example, to the
                extent unenforceable under the New Jersey Punitive Damages Act,
                New Jersey Products Liability Act, New Jersey Uniform Commercial
                Code and New Jersey Consumer Fraud Act); (ii) the limitations of
                liability for lost profits or loss or misuse of any data (for
                example, to the extent unenforceable under the New Jersey
                Identity Theft Protection Act and New Jersey Consumer Fraud
                Act); (iii) application of the limitations of liability to the
                recovery of damages that arise under contract and tort,
                including negligence, strict liability or any other theory (for
                example, to the extent such damages are recoverable by a
                consumer under New Jersey law, including the New Jersey Products
                Liability Act); (iv) the requirement that you indemnify Spotify
                and the Indemnified Parties (for example, to the extent the
                scope of such indemnity is prohibited under New Jersey law); (v)
                the limitation on your time for filing a claim against Spotify
                hereunder, to the extent that such limitation in connection with
                a claim is shorter than the applicable limitation under New
                Jersey law; and (vi) the New York governing law provision (for
                example, to the extent that your rights as a consumer residing
                in New Jersey are required to be governed by New Jersey law).
              </p>
            </li>
            <li>
              <h3>Entire Agreement and Severability.</h3>
              <p>
                These Terms are the entire agreement between you and us with
                respect to the Services and supersede all prior or
                contemporaneous communications and proposals (whether oral,
                written or electronic) between you and us with respect to the
                Services. If any provision of these Terms is found to be
                unenforceable or invalid, that provision will be limited or
                eliminated to the minimum extent necessary so that these Terms
                will otherwise remain in full force and effect and enforceable.
                The failure of either party to exercise in any respect any right
                provided for herein will not be deemed a waiver of any further
                rights hereunder
              </p>
            </li>
            <li>
              <h3>Force Majeure.</h3>
              <p>
                We will not be liable for any failure to perform our obligations
                hereunder where such failure results from any cause beyond our
                reasonable control, including, without limitation, mechanical,
                electronic or communications failure or degradation.
              </p>
            </li>
            <li>
              <h3>Assignment.</h3>
              <p>
                These Terms are personal to you, and are not assignable,
                transferable or sublicensable by you except with our prior
                written consent. We may assign, transfer or delegate any of our
                rights and obligations hereunder, in whole or in part, without
                your consent and without notice to you.
              </p>
            </li>
            <li>
              <h3>Agency.</h3>
              <p>
                No agency, partnership, joint venture, or employment
                relationship is created as a result of these Terms and neither
                party has any authority of any kind to bind the other in any
                respect.
              </p>
            </li>
            <li>
              <h3>Notices.</h3>
              <p>
                Unless otherwise specified in these Terms, all notices under
                these Terms will be in writing and will be deemed to have been
                duly given when received, if personally delivered or sent by
                certified or registered mail, return receipt requested; when
                receipt is electronically confirmed, if transmitted by facsimile
                or e-mail; or the day after it is sent, if sent for next day
                delivery by recognized overnight delivery service. Electronic
                notices should be sent to via our help page.
              </p>
            </li>
            <li>
              <h3>No Waiver.</h3>
              <p>
                Our failure to enforce any part of these Terms will not
                constitute a waiver of our right to later enforce that or any
                other part of these Terms. Waiver of compliance in any
                particular instance does not mean that we will waive compliance
                in the future. In order for any waiver of compliance with these
                Terms to be binding, we must provide you with written notice of
                such waiver through one of our authorized representatives.
              </p>
            </li>
            <li>
              <h3>Headings.</h3>
              <p>
                The Section and paragraph headings in these Terms are for
                convenience only and will not affect their interpretation.
              </p>
            </li>
          </ol>
        </section>
        <section>
          <h2>16. Apple Devices and Application Terms</h2>
          <p>
            If you have downloaded the App from the Apple, Inc. (“
            <strong>Apple</strong>”) App Store or if you are using the App on an
            iOS device, you acknowledge that you have read, understood, and
            agree to the following notice regarding Apple. This Agreement is
            between you and Spotify only, not with Apple, and Apple is not
            responsible for the Service and the content thereof. Apple has no
            obligation whatsoever to furnish any maintenance and support
            services with respect to the Service. In the event of any failure of
            the Service to conform to any applicable warranty, then you may
            notify Apple and Apple will refund any applicable purchase price for
            the App to you; and, to the maximum extent permitted by applicable
            law, Apple has no other warranty obligation whatsoever with respect
            to the Service. Apple is not responsible for addressing any claims
            by you or any third party relating to the Service or your possession
            and/or use of the Service, including: (1) product liability claims;
            (2) any claim that the Service fails to conform to any applicable
            legal or regulatory requirement; and (3) claims arising under
            consumer protection or similar legislation. Apple is not responsible
            for the investigation, defense, settlement and discharge of any
            third party claim that the Service and/or your possession and use of
            the App infringe that third party’s intellectual property rights.
            You agree to comply with any applicable third party terms, when
            using the Service. Apple, and Apple’s subsidiaries, are third party
            beneficiaries of this Agreement, and upon your acceptance of this
            Agreement, Apple will have the right (and will be deemed to have
            accepted the right) to enforce this Agreement against you as a third
            party beneficiary of this Agreement. You hereby represent and
            warrant that (1) you are not located in a country that is subject to
            a U.S. Government embargo, or that has been designated by the U.S.
            Government as a “terrorist supporting” country; and (2) you are not
            listed on any U.S. Government list of prohibited or restricted
            parties.
          </p>
        </section>
        <section>
          <h2>17. Contact</h2>
          <p>
            For customer support queries, please contact our customer service
            department using our customer support page at{' '}
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://help.anchor.fm"
            >
              help.anchor.fm
            </a>
          </p>
        </section>
      </div>
    </div>
  );
}
